import './TechInfoManuals.scss';
import { ErrorDisplayComponent, ErrorBoundary, PageTitle, LoadingCircle, Breadcrumbs } from '@gplibraries/react/components';
import { ContentTable } from '@gplibraries/react/components';
import { useTokenProvider, useConfig, useLogger } from '@gplibraries/react/hooks';
import { useQuery } from '@tanstack/react-query';
import { fetchTechInfoManuals } from '../../api/techDocuments.js';

export default function TechInfoManuals() {

  const logger = useLogger();
  const { dealerAccessApiScope, dealerAccessApiHost } = useConfig();
  const tableConfig = useConfig('techManualsTableConfig');
  const getToken = useTokenProvider({ scopes: [dealerAccessApiScope]});

  // middleware token query
  const { data: token, isLoading: tokenLoading } = useQuery({
    enabled: Boolean(getToken),
    queryKey: ['middlewareToken'],
    queryFn: () => getToken!()
  });

  // Fetch manuals
  const { isPending: loading, error, data: manuals } = useQuery({
    enabled: Boolean(token),
    queryKey: ['tech_documents', 'manuals'],
    queryFn: () => getToken!()
      .then(token => fetchTechInfoManuals(dealerAccessApiHost, token!.accessToken))
      .then(res => res.json()),
    select: (data) => data.data
  })

  // let error boundary handle this
  if (error) throw error;

  return (
    <>

      {/* Providing manual breadcrumbs here since "techincal-documents" is not an actual page.*/}
      <Breadcrumbs breadcrumbs={{
        'Technical Documents': '/technical-documents/manuals',
        'Manuals': '/technical-documents/manuals'
      }}/>

      <PageTitle>Technical Information Manuals</PageTitle>

      {(loading || tokenLoading) && <LoadingCircle className={'large color'}/>}

      {manuals?.length &&
        <section className={'block shadow full'}>
          <ErrorBoundary
            fallback={<ErrorDisplayComponent message={'Technical Information Manuals could not be loaded.'}/>}
            logger={logger}
          >

            <ContentTable
              content={manuals.map((manual: any) => ({
                manual_id: manual.title,
                manual_file: { text: manual.field_manual_file.filename, url: manual.field_manual_file.uri },
                manual_description: manual.field_manual_description,
                machine_type: manual.field_machine_type.name,
                post_date: manual.created
              }))}
              tableConfig={tableConfig}
            />

          </ErrorBoundary>
        </section>
      }

    </>
  );
}